import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { CancelReservationRequest } from '@/types/request/CancelReservationRequest';
import { queryClient } from '@/main.tsx';

const useReservationCancel = () => {
  const client = supabaseClient;

  const mutationFn = async (request: CancelReservationRequest) => {
    return cancelReservation(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['reservations'] });
    },
  });
};

export default useReservationCancel;

async function cancelReservation(client: SupabaseClient, request: CancelReservationRequest): Promise<void> {
  const { error } = await client.functions.invoke('cancel-reservation', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();

    if (errorMessage.message) {
      throw new Error(errorMessage.message);
    }

    if (errorMessage.error) {
      throw new Error(errorMessage.error);
    }

    throw new Error(error.message);
  }

  if (error) throw new Error('Failed to cancel reservation. Try again later.');

  return;
}
